import { ReactComponent as ReactLogo } from './icons8-react-native.svg';

function NavBar() {
  return (
    <div>
      <nav className="flex items-center justify-between flex-wrap bg-blue-600 p-6">
        <div className="flex items-center flex-shrink-0 text-white mr-6">
          <ReactLogo />
          <span className="font-semibold text-xl tracking-tight ml-2">
            Image Search
          </span>
        </div>
        <div className="">
          <p className="block mt-3 lg:inline-block lg:mt-0 md:pr-5 text-xl text-white hover:text-gray-400 mr-4 transition-all">
            Search for any images via the Pixabay API
          </p>
        </div>
      </nav>
    </div>
  );
}

export default NavBar;
